import React, { useState } from "react";
import { IBulkRegRequest } from "../../typings/interfaces/Requests/BulkRegRequest";
import { SaveBulkRegistration } from "../../api/apimethods";
import { useNavigate } from "react-router-dom";
import { AppContext, defaultAppContextData } from "../../services/appData";
import { useAuthService, useContextService } from "../../services";
import Loader from "../../components/molecules/Loader";

interface UploadedFile {
  name: string;
  date: string;
  file: File;
}

interface FilePreviewProps {
  selectedFile: UploadedFile;
  excelData: any[][];
  onFileSelect: () => void;
  RegistrationType: any;
  columnsToExtract: number[];
  bulkRequestedData: IBulkRegRequest;
}

const FilePreview: React.FC<FilePreviewProps> = ({
  selectedFile,
  excelData,
  onFileSelect,
  RegistrationType,
  columnsToExtract,
  bulkRequestedData,
}) => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;

  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmiting, setSubmiting] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [uploadFileError, setUploadFileError] = useState(false);
  const [invalidFileError, setInvalidFileError] = useState(false);
  const bulkRegRequests: IBulkRegRequest[] = [];
  let navigate = useNavigate();

  const fixTimezoneOffset = (date: Date | null): Date | null => {
    if (!date) return null;
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  };

  const arrayBufferToBase64 = (buffer: ArrayBuffer | Uint8Array) => {
    let binary = "";
    const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  };

  const formatDate = (dateValue: any) => {
    if (!dateValue) return "";
  
    // Handle Excel Serial Numbers
    if (!isNaN(dateValue) && Number(dateValue) > 10000) {
      return new Date(Date.UTC(1899, 11, 30) + dateValue * 86400000).toLocaleString("en-GB");
    }
  
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return dateValue;
    //return date.toLocaleDateString("en-GB"); // Format: "DD/MM/YYYY"
    return date.toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" });
  };
  

  const isDateTime = (value: any) => {
    if (!value) return false;
  
    // If value is a number and within Excel's serial date range
    if (!isNaN(value) && Number(value) > 10000) return true;
  
    const date = new Date(value);
    return !isNaN(date.getTime()); // Returns true if it's a valid date
  };
  

  const handleFormSubmit = async () => {
    const makeApiCall = async () => {
      try {
        setSubmiting(true);
        setDisableSubmit(true);
        // Make the API call using the bulkRegRequests array
        const response = await SaveBulkRegistration(bulkRegRequests);
        if (response.data.data) {
          setSubmiting(false);
          setDisableSubmit(false);
          var sSourceofFish =
            bulkRequestedData.applicationInformation.sourceofFish;
          let path = `/Single-Reg-Complete`;
          navigate(path, { state: { RegistrationType, sSourceofFish } });
        } else {
          setSubmiting(false);
          setDisableSubmit(false);
          const errorMessage = response.data.message;
          setErrorMessage(errorMessage);
        }
      } catch (error) {
        // Handle any errors that occurred during the API call
        console.error("API Error:", error);
      }
    };
    const buffer = await selectedFile.file.arrayBuffer();

    const data = new Uint8Array(buffer);
    const base64data = arrayBufferToBase64(data);
    const uploadedDocument = {
      fileName: selectedFile.name,
      file: base64data,
    };

    if (excelData.length <= 1) {
      setUploadFileError(true);

      return;
    }
    if (excelData.length > 1) {
      let columns = 0;
      if (
        (RegistrationType.RegistrationType === "DragonFish" ||
          RegistrationType === "DragonFish") &&
        bulkRequestedData.applicationInformation.sourceofFish === "2"
      )
      {
        columns = 3;
      }
      else if(RegistrationType === "Birds")
      {
        columns = 3;
      }
      else 
      {
        columns = 1;
      }
      // for (let index = 1; index < excelData.length; index++) {
      //   if (excelData[index].length > columns) {
      //     setInvalidFileError(true);

      //     return;
      //   }
      // }

      // for (let index = 1; index < excelData.length; index++) {
      //   for (let column = 0; column < columns; column++) {
      //     if (
      //       excelData[index][column] === "" ||
      //       excelData[index][column] === undefined
      //     ) {
      //       setInvalidFileError(true);

      //       return;
      //     }
      //   }
      // }
    }
    if (excelData.length > 0) {
      if (
        RegistrationType.RegistrationType === "DragonFish" ||
        RegistrationType === "DragonFish"
      ) {
        RegistrationType = "DragonFish";
        const varietyOfFishArray = [
          { id: 1, text: "Red" },
          { id: 2, text: "Gold" },
          { id: 3, text: "Green" },
          // Add more objects with text properties as needed
        ];

        const lengthOfFishArray = [
          { id: 1, text: "12-15 cm" },
          { id: 2, text: "16-20cm" },
          { id: 3, text: "More than 20cm" },
          // Add more objects with text properties as needed
        ];

        for (let index = 1; index < excelData.length; index++) {
          let varietyOfFish = 0;
          let lengthOfFish = 0;
          if (
            excelData[index][1] !== undefined &&
            excelData[index][1].toString() != undefined
          ) {
            var v = varietyOfFishArray.find(
              (item) => item.text === excelData[index][1].toString()
            );
            if (v) {
              varietyOfFish = v.id;
            }
          }

          if (
            excelData[index][2] !== undefined &&
            excelData[index][2].toString() != undefined
          ) {
            var l = lengthOfFishArray.find(
              (item) => item.text === excelData[index][2].toString()
            );
            if (l) {
              lengthOfFish = l.id;
            }
          }
          const bulkRequestData: IBulkRegRequest = {
            regName: bulkRequestedData.regName,
            mode: 2,
            userInformation: {
              name: user?.name,
              idType: user?.idType,
              idNo: user?.idNo,
              email: user?.email,
              contactNo: user?.contactNo,
              companyName: user?.companyName,
              uen: user?.uen,
              registeredAddress: user?.registeredAddresses?.[0],
            },
            personalInformation: {
              salutation: bulkRequestedData.personalInformation.salutation,
              name: bulkRequestedData.personalInformation.name,
              uen: bulkRequestedData.personalInformation.uen,
              nric: bulkRequestedData.personalInformation.nric,
              companyName: bulkRequestedData.personalInformation.companyName,
              organizationAddress:
                bulkRequestedData.personalInformation.organizationAddress,
              typeofPremises:
                bulkRequestedData.personalInformation.typeofPremises,
              blockHouseNumber:
                bulkRequestedData.personalInformation.blockHouseNumber,
              houseNumber: bulkRequestedData.personalInformation.houseNumber,
              streetName: bulkRequestedData.personalInformation.streetName,
              floorNumber: bulkRequestedData.personalInformation.floorNumber,
              unitNumber: bulkRequestedData.personalInformation.unitNumber,
              buildingName: bulkRequestedData.personalInformation.buildingName,
              postalCode: bulkRequestedData.personalInformation.postalCode,
              country: bulkRequestedData.personalInformation.country,
              mobileNo: bulkRequestedData.personalInformation.mobileNo,
              email: bulkRequestedData.personalInformation.email,
              mobileNoCode: bulkRequestedData.personalInformation.mobileNoCode,
              licenceNumber:
                bulkRequestedData.personalInformation.licenceNumber,
              premiseCode:
                bulkRequestedData.personalInformation.premiseCode,
            },
            applicationInformation: {
              fcRegistrationNo:
                bulkRequestedData.applicationInformation.fcRegistrationNo,
              countryOrigin:
                bulkRequestedData.applicationInformation.countryOrigin,
              scientificName:
                bulkRequestedData.applicationInformation.scientificName,
              citesAppendixNo:
                bulkRequestedData.applicationInformation.citesAppendixNo,
              foreignCITESPermitNo:
                bulkRequestedData.applicationInformation.foreignCITESPermitNo,
                farmCode:"",
              legRingNo: "",
              TypeofTag: 0,
              TagNumber: "",
              VarietyofFish:
                bulkRequestedData.applicationInformation.sourceofFish === "1"
                  ? bulkRequestedData.applicationInformation.VarietyofFish
                  : varietyOfFish,
              LengthofFish:
                bulkRequestedData.applicationInformation.sourceofFish === "1"
                  ? bulkRequestedData.applicationInformation.LengthofFish
                  : lengthOfFish,
              BatchNumber: bulkRequestedData.applicationInformation.BatchNumber,
              RegisteredQuantityinBatch:
                bulkRequestedData.applicationInformation
                  .RegisteredQuantityinBatch,
              HarvestDate: fixTimezoneOffset(
                bulkRequestedData.applicationInformation.HarvestDate
              ),
              HatchDate: null,
              ParentMicrochip:
                bulkRequestedData.applicationInformation.ParentMicrochip,
              Remarks: bulkRequestedData.applicationInformation.Remarks,
              MicrochipNumber: excelData[index][0].toString(),
              sourceofFish:
                bulkRequestedData.applicationInformation.sourceofFish,
              expiryDate: bulkRequestedData.applicationInformation.expiryDate,
              // registrationMode: "2",
            },
            registrationType: 3,
            uploadedDocument: uploadedDocument,
          };

          bulkRegRequests.push(bulkRequestData);
        }
      } else if (
        RegistrationType.RegistrationType === "Crocodile" ||
        RegistrationType === "Crocodile"
      ) {
        RegistrationType = "Crocodile";
        for (let index = 1; index < excelData.length; index++) {
          const bulkRequestData: IBulkRegRequest = {
            regName: bulkRequestedData.regName,
            mode: 2,
            userInformation: {
              name: user?.name,
              idType: user?.idType,
              idNo: user?.idNo,
              email: user?.email,
              contactNo: user?.contactNo,
              companyName: user?.companyName,
              uen: user?.uen,
              registeredAddress: user?.registeredAddresses?.[0],
            },
            personalInformation: {
              salutation: bulkRequestedData.personalInformation.salutation,
              name: bulkRequestedData.personalInformation.name,
              uen: bulkRequestedData.personalInformation.uen,
              nric: bulkRequestedData.personalInformation.nric,
              companyName: bulkRequestedData.personalInformation.companyName,
              organizationAddress:
                bulkRequestedData.personalInformation.organizationAddress,
              typeofPremises:
                bulkRequestedData.personalInformation.typeofPremises,
              blockHouseNumber:
                bulkRequestedData.personalInformation.blockHouseNumber,
              houseNumber: bulkRequestedData.personalInformation.houseNumber,
              streetName: bulkRequestedData.personalInformation.streetName,
              floorNumber: bulkRequestedData.personalInformation.floorNumber,
              unitNumber: bulkRequestedData.personalInformation.unitNumber,
              buildingName: bulkRequestedData.personalInformation.buildingName,
              postalCode: bulkRequestedData.personalInformation.postalCode,
              country: bulkRequestedData.personalInformation.country,
              mobileNo: bulkRequestedData.personalInformation.mobileNo,
              email: bulkRequestedData.personalInformation.email,
              mobileNoCode: bulkRequestedData.personalInformation.mobileNoCode,
              licenceNumber: "",
              premiseCode:
                bulkRequestedData.personalInformation.premiseCode,
            },
            applicationInformation: {
              fcRegistrationNo: "",
              countryOrigin:
                bulkRequestedData.applicationInformation.countryOrigin,
              scientificName:
                bulkRequestedData.applicationInformation.scientificName,
              citesAppendixNo:
                bulkRequestedData.applicationInformation.citesAppendixNo,
              foreignCITESPermitNo:
                bulkRequestedData.applicationInformation.foreignCITESPermitNo,
              farmCode:"",
              legRingNo: "",
              TypeofTag: bulkRequestedData.applicationInformation.TypeofTag,
              TagNumber: excelData[index][0].toString(),
              VarietyofFish: 0,
              LengthofFish: 0,
              BatchNumber: "",
              RegisteredQuantityinBatch: 0,
              HarvestDate: null,
              HatchDate: fixTimezoneOffset(
                bulkRequestedData.applicationInformation.HatchDate
              ),
              ParentMicrochip: "",
              Remarks: "",
              MicrochipNumber: "",
              sourceofFish: "",
              expiryDate: null,
              // registrationMode: "2",
            },
            registrationType: 2,
            uploadedDocument: uploadedDocument,
          };

          bulkRegRequests.push(bulkRequestData);
        }
      } else {
        RegistrationType = "Bird";
        for (let index = 1; index < excelData.length; index++) {
          const bulkRequestData: IBulkRegRequest = {
            regName: bulkRequestedData.regName,
            mode: 2,
            userInformation: {
              name: user?.name,
              idType: user?.idType,
              idNo: user?.idNo,
              email: user?.email,
              contactNo: user?.contactNo,
              companyName: user?.companyName,
              uen: user?.uen,
              registeredAddress: user?.registeredAddresses?.[0],
            },
            personalInformation: {
              salutation: bulkRequestedData.personalInformation.salutation,
              name: bulkRequestedData.personalInformation.name,
              uen: bulkRequestedData.personalInformation.uen,
              nric: bulkRequestedData.personalInformation.nric,
              companyName: bulkRequestedData.personalInformation.companyName,
              organizationAddress:
                bulkRequestedData.personalInformation.organizationAddress,
              typeofPremises:
                bulkRequestedData.personalInformation.typeofPremises,
              blockHouseNumber:
                bulkRequestedData.personalInformation.blockHouseNumber,
              houseNumber: bulkRequestedData.personalInformation.houseNumber,
              streetName: bulkRequestedData.personalInformation.streetName,
              floorNumber: bulkRequestedData.personalInformation.floorNumber,
              unitNumber: bulkRequestedData.personalInformation.unitNumber,
              buildingName: bulkRequestedData.personalInformation.buildingName,
              postalCode: bulkRequestedData.personalInformation.postalCode,
              country: bulkRequestedData.personalInformation.country,
              mobileNo: bulkRequestedData.personalInformation.mobileNo,
              email: bulkRequestedData.personalInformation.email,
              mobileNoCode: bulkRequestedData.personalInformation.mobileNoCode,
              licenceNumber: "",
              premiseCode:
                bulkRequestedData.personalInformation.premiseCode,
            },
            applicationInformation: {
              fcRegistrationNo:
                bulkRequestedData.applicationInformation.fcRegistrationNo,
              countryOrigin:
                bulkRequestedData.applicationInformation.countryOrigin,
              scientificName:
                bulkRequestedData.applicationInformation.scientificName,
              citesAppendixNo:
                bulkRequestedData.applicationInformation.citesAppendixNo,
              foreignCITESPermitNo:
                bulkRequestedData.applicationInformation.foreignCITESPermitNo,
              farmCode:bulkRequestedData.applicationInformation.farmCode,
              legRingNo: excelData[index][0].toString(),
              TypeofTag: 0,
              TagNumber: "",
              VarietyofFish: 0,
              LengthofFish: 0,
              BatchNumber: "",
              RegisteredQuantityinBatch: 0,
              HarvestDate: null,
              HatchDate: fixTimezoneOffset(
                bulkRequestedData.applicationInformation.HatchDate
              ),
              ParentMicrochip: "",
              Remarks: "",
              MicrochipNumber: "",
              sourceofFish: "",
              expiryDate: null,
              // registrationMode: "2",
            },
            registrationType: 1,
            uploadedDocument: uploadedDocument,
          };

          bulkRegRequests.push(bulkRequestData);
        }
      }

      makeApiCall();
    }
  };
  return (
    <div className="inner-content">
      <div className="container">
        <div className="landing-page form-upload">
          <p>Preview of the Form Uploaded</p>
          <div className="landing-list">
            <div className="row">
              <div className="col-lg-10">
                <h3>{selectedFile.name}</h3>
              </div>
              <div className="col-lg-2">
                <button className="btn-back" onClick={onFileSelect}>
                  Back
                </button>
              </div>
            </div>

            <div className="table-responsive mt-4 mb-2">
              <table className="table table-striped start_table">
                <thead>
                  <tr>
                    {/* <th style={{ textAlign: "center" }}>#SN</th> */}
                    {/* Sequential number column */}
                    {columnsToExtract.map((columnIndex: number) => (
                      <th className="csp-text-left" key={columnIndex}>
                        {excelData[0][columnIndex]}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {excelData.length > 1 &&
                    excelData.slice(1).map((row: any[], rowIndex: number) => (
                      <tr key={rowIndex}>
                        {/* <td style={{ textAlign: "center" }}>{rowIndex + 1}</td> */}
                        {/* Sequential number value */}
                        {columnsToExtract.map((columnIndex: number) => (
                          <td className="csp-text-left" key={columnIndex}>
                            {RegistrationType === "Birds" && columnIndex === 1 && (formatDate(row[columnIndex]) )}
                            {RegistrationType === "Birds" && columnIndex !== 1 && (row[columnIndex] )}
                            {RegistrationType !== "Birds" && (row[columnIndex] )}
                          </td>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {/* <button className="btn-back text-center" onClick={onFileSelect}>
              Show More
            </button> */}
          </div>
          {uploadFileError && (
            <div className="error-message  mb-3">
              No data in the uploaded file. Kindly re-upload the filled-up form
            </div>
          )}
          {invalidFileError && (
            <div className="error-message  mb-3">
              Invalid data in the file. Please correct your data and re-upload.
            </div>
          )}
          <button
            type="button"
            className="btn btn-success mt-4"
            onClick={handleFormSubmit}
            disabled={disableSubmit}
          >
            Submit Form
          </button>
        </div>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        {isSubmiting && <Loader />}
      </div>
    </div>
  );
};

export default FilePreview;
